/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers{
    export interface RelatedClaimProcessTypeScope extends angular.IScope {
        model: models.RelatedClaimProcessTypeModel;

    }

    export class RelatedClaimProcessTypeController {
        constructor(scope: RelatedClaimProcessTypeScope, $routeParams: angular.route.IRouteParamsService,
            private relatedClaimProcessTypeService: services.RelatedClaimProcessTypeService,
        private processConfigurationService:services.ProcessConfigurationService) {

            var processConfigurationId: string = $routeParams["id"];
            scope.model = new models.RelatedClaimProcessTypeModel(processConfigurationId,relatedClaimProcessTypeService,processConfigurationService);

        }
    }
}

warsApp.registerController('RelatedClaimProcessTypeController', ['$scope', '$routeParams','relatedClaimProcessTypeService','processConfigurationService']);